// InvoiceStatusCell.tsx
import { FC } from "react";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

interface IInvoiceStatusCellProps {
    status: string; // 'blue' | 'green' | 'red' | 'yellow'
}

export const InvoiceStatusCell: FC<IInvoiceStatusCellProps> = ({ status }) => {
    const { t } = useTranslation();

    const getStatusColor = (status: string): string => {
        const colors: Record<string, string> = {
            blue: '#2196f3',
            green: '#4caf50',
            red: '#f44336',
            yellow: '#ff9800'
        };
        return colors[status] || '#9e9e9e';
    };

    const getStatusTooltip = (status: string): string => {
        const tooltips: Record<string, string> = {
            blue: t('documents.invoice.status.blue'),
            green: t('documents.invoice.status.green'),
            red: t('documents.invoice.status.red'),
            yellow: t('documents.invoice.status.yellow')
        };
        return tooltips[status] || t('documents.invoice.status.unknown');
    };

    return (
        <Tooltip title={getStatusTooltip(status)} placement="top">
            <div
                style={{
                    width: 20,
                    height: 20,
                    borderRadius: '50%',
                    backgroundColor: getStatusColor(status),
                    cursor: 'pointer'
                }}
            />
        </Tooltip>
    );
};